// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__YbzD2","productName":"Table_productName__1b0WP"};